var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOperationTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D1F27A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9792 10.5006C20.999 10.7383 21.009 10.8572 21.0704 10.9212C21.1318 10.9851 21.2542 11.0004 21.499 11.0308C23.4726 11.2764 25 12.9598 25 15C25 17.2091 23.2091 19 21 19H20.5C20.2643 19 20.1464 19 20.0732 18.9268C20 18.8536 20 18.7357 20 18.5V17C20 15.1144 20 14.1716 19.4142 13.5858C18.8284 13 17.8856 13 16 13H14C12.1144 13 11.1716 13 10.5858 13.5858C10 14.1716 10 15.1144 10 17V18.5C10 18.7357 10 18.8536 9.92678 18.9268C9.85355 19 9.7357 19 9.5 19H9C6.79086 19 5 17.2091 5 15C5 12.9598 6.52736 11.2764 8.50099 11.0308C8.74578 11.0004 8.86817 10.9851 8.9296 10.9212C8.99103 10.8572 9.00096 10.7383 9.02082 10.5006C9.03959 10.2758 9.07107 10.0517 9.11529 9.82946C9.29484 8.92682 9.67962 8.07758 10.2399 7.34743C10.8001 6.61729 11.5208 6.02581 12.3463 5.61876C13.1717 5.21171 14.0797 5 15 5C15.9203 5 16.8283 5.21171 17.6537 5.61876C18.4791 6.02581 19.1999 6.61729 19.7601 7.34743C20.3204 8.07757 20.7052 8.92682 20.8847 9.82946C20.9289 10.0517 20.9604 10.2758 20.9792 10.5006Z",
    fill: "url(#paint0_linear_1405_18370)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5858 14.5858C11 15.1716 11 16.1144 11 18V20C11 21.8856 11 22.8284 11.5858 23.4142C12.1716 24 13.1144 24 15 24C16.8856 24 17.8284 24 18.4142 23.4142C19 22.8284 19 21.8856 19 20V18C19 16.1144 19 15.1716 18.4142 14.5858C17.8284 14 16.8856 14 15 14C13.1144 14 12.1716 14 11.5858 14.5858ZM14.5 18C13.9477 18 13.5 18.4477 13.5 19C13.5 19.5523 13.9477 20 14.5 20H15.5C16.0523 20 16.5 19.5523 16.5 19C16.5 18.4477 16.0523 18 15.5 18H14.5Z",
    fill: "url(#paint1_linear_1405_18370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1405_18370",
    x1: 25,
    y1: 12,
    x2: 5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06362B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692308,
    stopColor: "#052921"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1405_18370",
    x1: 19,
    y1: 19,
    x2: 11,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06362B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692308,
    stopColor: "#052921"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOperationTraining);
export default __webpack_public_path__ + "static/media/ic_operation_training.bd5e72441fabafc8bfefe2d21ef71361.svg";
export { ForwardRef as ReactComponent };